<div class="sc-message--emoji">{message.data.emoji}</div>

<style>
 .sc-message--emoji {
   font-size: 40px;
 }

</style>

<script>
 export default {
 }

</script>
